import { Grid, InputAdornment, Typography } from "@mui/material";

import { AdornmentButton } from "components/GeneralStyled";
import PriceInput from "components/PriceInput";
import { useFormContext } from "react-hook-form";

function BorrowAmount({ selectedCoin, borrowAmountMax, loading }) {
  const { watch, setValue } = useFormContext();
  const amount = watch("amount");

  return (
    <Grid item xs={12}>
      <Typography variant="h6" color="text.main">
        Borrow Amount
      </Typography>

      <PriceInput
        value={amount}
        onChange={(e) => setValue("amount", e)}
        placeholder="Amount"
        showPrefix={false}
        disabled={loading}
        allowNegative={true}
        maxDecimal={8}
        coinName={selectedCoin?.coinName}
        max={borrowAmountMax?.borrowAmountMax || 0}
        min={selectedCoin?.minimumBorrowAmount || 0}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <AdornmentButton
                variant="text"
                color="secondary"
                disabled={loading}
                onClick={() =>
                  setValue("amount", borrowAmountMax?.borrowAmountMax)
                }
              >
                Max
              </AdornmentButton>
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
}

export default BorrowAmount;
